import axios from "./axios";
import AppConfig from "../../config";

export default class customerService {
  getCustomerProfile = async (cusRefId) => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.BUSINESS_PARTNER_MANAGER_PORT}/v5/business-partner/manager/company/${AppConfig.COM_CODE}/customer-profile/customer-ref-id/`+cusRefId;
    //console.log("getCustomerProfile url", url);
    const config = {
      method: "get",
      url: url,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer",
      },
    };
    const results = await axios.get(url, config);
    const response = await results.data;
    //console.log("getCustomerProfile response: ", JSON.stringify(response));
    return response;
  };
}

export { customerService }